export default __webpack_public_path__ + "media/siteware/favicon-70-064686c6e8c57f7b2d0266b074911361.png";